var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7524 0.430612C11.6446 0.322868 11.51 0.245813 11.3625 0.207384C11.215 0.168955 11.0599 0.170542 10.9133 0.211981H10.9052L0.619945 3.33282C0.452968 3.38094 0.304556 3.47867 0.194376 3.61304C0.0841952 3.74742 0.0174475 3.91211 0.00297801 4.08527C-0.0114914 4.25844 0.0270004 4.43192 0.113353 4.58272C0.199705 4.73352 0.329841 4.85452 0.486516 4.92968L5.03703 7.14599L7.25012 11.6938C7.31896 11.8407 7.4284 11.9648 7.56551 12.0515C7.70262 12.1382 7.86168 12.1839 8.0239 12.1831C8.04855 12.1831 8.0732 12.182 8.09785 12.1798C8.27088 12.1658 8.43549 12.0992 8.56958 11.989C8.70368 11.8788 8.80085 11.7301 8.84805 11.5631L11.9668 1.2778C11.9668 1.27513 11.9668 1.27245 11.9668 1.26977C12.0087 1.12346 12.011 0.968611 11.9733 0.821134C11.9357 0.673658 11.8594 0.538868 11.7524 0.430612ZM8.02873 11.3177L8.02605 11.3252V11.3214L5.8794 6.91129L8.45152 4.33916C8.52852 4.25812 8.57081 4.15019 8.56938 4.03841C8.56795 3.92662 8.52291 3.81982 8.44386 3.74077C8.36481 3.66172 8.258 3.61668 8.14622 3.61525C8.03443 3.61381 7.92651 3.65611 7.84546 3.73311L5.27334 6.30523L0.861617 4.15858H0.857866H0.865368L11.1458 1.0372L8.02873 11.3177Z",
    fill: "#8B8C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.930154cd6fa0625a1ecf8a6037bec717.svg";
export { ForwardRef as ReactComponent };